// document.addEventListener("DOMContentLoaded", function () {
//   var containers = document.querySelectorAll(".flickity-viewport");

//   containers.forEach(function (container) {
//     container.style.width = "100%";
//     container.style.setProperty("width", "100%", "important"); // Add !important to the width property
//   });
//   var sliders = document.querySelectorAll(".flickity-slider");

//   //   sliders.forEach(function (slider) {
//   //     slider.style.transform = 'none';
//   //     slider.style.setProperty('transform', 'none', 'important'); // Add !important to the width property
//   //   });
// });

if (typeof window.IntersectionObserver !== "undefined") {
  let options = {
    threshold: [0.5, 1],
  };
  const targets = document.querySelectorAll(".cb");
  const locker = document.querySelector(".locker__container");
  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        entry.target.current = entry.target.dataset.swap;
        document
          .querySelector(".locker__container ." + entry.target.current)
          .classList.add("active");
      } else {
        document
          .querySelector(".locker__container ." + entry.target.current)
          .classList.remove("active");
      }
    });
  }
  const observer = new IntersectionObserver(handleIntersection, options);
  targets.forEach((target) => observer.observe(target));
} else {
  // Fallback
}

/*
 * Hover Image Slider
 * used in the Horr WordPress Theme
 * https://horr.nkdev.info/landing/
 */
const slider = document.querySelector(".horr-hover-slider");
const links = document.querySelectorAll(".horr-hover-slider-link");
const label = document.querySelectorAll(".horr-hover-slider-label");
const labelDefaultText = label[0].textContent;

function splitText(string) {
  // Clean label text.
  label[0].innerHTML = "";

  let transition = 0;

  // Split text.
  string.split("").forEach((symbol) => {
    transition += 40;

    // Create span with text.
    const span = document.createElement("span");
    span.innerHTML = symbol;

    // Add transition delay in the Span Label.
    span.style.transitionDelay = `${transition}ms`;

    // Add show class.
    setTimeout(() => {
      span.classList.add("show");
    }, 10);

    // Add split text in the Label.
    label[0].append(span);
  });
}

links.forEach((link) => {
  link.addEventListener(
    "mouseenter",
    function () {
      splitText(
        this.querySelector(".horr-hover-slider-link-heading").innerText
      );
    },
    false
  );
});

slider.addEventListener(
  "mouseleave",
  function () {
    splitText(labelDefaultText);
  },
  false
);
// external js: flickity.pkgd.js

var utils = window.fizzyUIUtils;

var carousel = document.querySelector(".carousel");
var flkty = new Flickity(carousel, {
  prevNextButtons: true,
  pageDots: false,
});
// elements
var cellsButtonGroup = document.querySelector(".button-group--cells");
var cellsButtons = utils.makeArray(cellsButtonGroup.children);

// update buttons on select
flkty.on("select", function () {
  var previousSelectedButton = cellsButtonGroup.querySelector(".is-selected");
  var selectedButton = cellsButtonGroup.children[flkty.selectedIndex];
  previousSelectedButton.classList.remove("is-selected");
  selectedButton.classList.add("is-selected");
});

// cell select
cellsButtonGroup.addEventListener("click", function (event) {
  if (!matchesSelector(event.target, ".button")) {
    return;
  }
  var index = cellsButtons.indexOf(event.target);
  flkty.select(index);
});
// previous
// var previousButton = document.querySelector('.button--previous');
// previousButton.addEventListener('click', function () {
//   flkty.previous();
// });
// // next
// var nextButton = document.querySelector('.button--next');
// nextButton.addEventListener('click', function () {
//   flkty.next();
// });
